export const divider = ({ theme: { colors }, top, bottom }) => ({
    backgroundColor: colors.blueGrey1,
    margin: `${top} 0 ${bottom}`,
    width: '100%',
    height: '1px',
});
